import { inject, observer } from 'mobx-preact'
import Nprogress from 'nprogress'
import React, { Component } from 'react'
import { form } from 'util'
import api from 'util/api'
import i18n from 'util/i18n'
import toast from 'util/toast'
import AV from '../av'
import { Input, Link, Submit } from './Base'

@inject('store')
@observer
@form
export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      wait: false
    }
  }
  async onSubmit(_e, obj) {
    let { store } = this.props
    let user = new AV.User()
    user.setUsername(obj.email)
    user.setPassword(obj.password)
    user.setEmail(obj.email)
    this.setState({wait: true})
    Nprogress.start()
    try {
      await user.signUp()
      await api({
        method: 'post',
        url: '/api/login',
        params: {
          email: obj.email,
          password: obj.password
        }
      })
      store.setStep('regist')
    } catch (error) {
      toast(error)
    } finally {
      this.setState({wait: false})
      Nprogress.done()
    }
  }
  render({ store }) {
    let { wait } = this.state
    let text = wait ? i18n('wait') : i18n('submit')
    return (
      <form id="signup-form" onSubmit={this.onSubmit.bind(this)}>
        <Input type="email" name="email" required placeholder={store.lang=='en' ? 'Enter your email' : '邮箱'}/>
        <Input type="password" name="password" required placeholder={store.lang=='en' ? 'Enter your password' : '密码'}/>
        <Submit value={text} disabled={wait == true} />
        <div class="login-links">
          <Link onClick={() => store.setStep('login')}>{i18n('have-account')}?</Link>
          <Link onClick={() => store.setStep('reset')}>{i18n('forgot-password')}?</Link>
        </div>
      </form>
    )
  }
}
